/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { ActionResultTitles, StatusCssClasses } from "../../../../../../../_helpers/Helpers";

export const ResultColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      StatusCssClasses[row.isSuccess]
    } label-inline`}
  >
    {ActionResultTitles[row.isSuccess]}
  </span>
);